export default __webpack_public_path__ + "static/media/TL13.6e3d113d.mp3";